<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Kalendar promocija
      </h1>
    </template>
    <template v-slot:default>
      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="sm:pl-6 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Mesto, vreme i status
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">

                  <tr v-for="(promotion, index) in promotions" :key="index">
                    <Promotion
                        :name="promotion.location"
                        :date="promotion.date"
                        :status="promotion.status"
                        :type="promotion.type"
                        :sales="promotion.products_total_sales"
                        :target="promotion.products_target"
                        :associate="promotion.associate"
                    />
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import Calendar from './Calendar';
export default Calendar;
</script>
